import { useNavigate } from 'react-router-dom';
import { tasaciones, usuario } from '../data/mock';

const estadoLabel = { formal: 'Formal', en_proceso: 'En proceso', borrador: 'Borrador' };
const tipoLabel = { departamento: 'Depto', casa: 'Casa', local: 'Local', oficina: 'Oficina', ph: 'PH', terreno: 'Terreno' };

function diasAtras(fecha) {
  const diff = Math.floor((new Date() - new Date(fecha)) / 86400000);
  if (diff === 0) return 'hoy';
  if (diff === 1) return 'ayer';
  if (diff < 7) return `hace ${diff} días`;
  return `hace ${Math.floor(diff / 7)} sem`;
}

export default function Dashboard() {
  const navigate = useNavigate();
  const formales = tasaciones.filter(t => t.estado === 'formal').length;
  const esteMes = tasaciones.filter(t => new Date(t.created_at).getMonth() === new Date().getMonth()).length;

  return (
    <div className="app-shell">
      <div className="topbar">
        <div>
          <div className="topbar-title">Buenos días, {usuario.nombre.split(' ')[0]}</div>
          <div className="topbar-sub">{usuario.organizacion} · {usuario.matricula}</div>
        </div>
        <span className="topbar-action">🔔</span>
      </div>

      <div className="page-body">
        <div className="pwa-banner">
          <span className="pwa-icon">📲</span>
          <span className="pwa-text">Instalá NTTasar en tu celular para acceso rápido</span>
          <span className="pwa-btn">Instalar</span>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-num">{tasaciones.length}</div>
            <div className="stat-label">Tasaciones totales</div>
          </div>
          <div className="stat-card">
            <div className="stat-num">{esteMes}</div>
            <div className="stat-label">Este mes</div>
          </div>
          <div className="stat-card">
            <div className="stat-num">{formales}</div>
            <div className="stat-label">Formales</div>
          </div>
          <div className="stat-card">
            <div className="stat-num" style={{ color: 'var(--teal)', fontSize: 18 }}>USD 1.875</div>
            <div className="stat-label">Último m² tasado</div>
          </div>
        </div>

        <div className="section-header">
          <span className="section-title">Tasaciones recientes</span>
          <span className="section-link" onClick={() => navigate('/tasaciones')}>Ver todas →</span>
        </div>

        {tasaciones.map(t => (
          <div key={t.id} className="tas-card" onClick={() => navigate(`/tasacion/${t.id}`)}>
            <div className="tas-card-info">
              <div className="tas-card-title">{t.direccion}</div>
              <div className="tas-card-sub">
                {tipoLabel[t.tipo]} · {t.sup_cubierta} m² · {diasAtras(t.created_at)}
              </div>
            </div>
            <div className="tas-card-right">
              <span className={`badge badge-${t.estado}`}>{estadoLabel[t.estado]}</span>
              {t.valor_estimado_usd && (
                <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--teal)' }}>
                  USD {t.valor_estimado_usd.toLocaleString()}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      <button className="fab" onClick={() => navigate('/nueva-tasacion')}>
        ＋ Nueva tasación
      </button>
    </div>
  );
}
